import { X } from 'lucide-react';
import './modal..css';
import { useEffect } from 'react';

export type ModalProps = {
  children: React.ReactNode;
  isOpen: boolean;
  close: React.Dispatch<React.SetStateAction<boolean>>;
  onCancel: () => void;
};

export const Modal = ({ children, isOpen, close, onCancel }: ModalProps) => {
  const handleOnCancel = () => {
    close(false);
    onCancel();
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={handleOnCancel} />

      <div className="modal-modal">
        <div className="modal-glowTop" />
        <div className="modal-glowBottom" />

        <div className="modal-content">
          <button
            className="modal-button-close"
            onClick={() => {
              close(false);
              onCancel();
            }}
          >
            <X stroke="#FFFFFF" />
          </button>

          {children}
        </div>
      </div>
    </div>
  );
};
